/* eslint-disable */
/* auto-generated by scripts/migrate-to-vite.mjs — do not edit by hand */
import { lazy, type ComponentType, type LazyExoticComponent } from "react";

export type AdminRoute = {
  path: string;
  Component: LazyExoticComponent<ComponentType<unknown>>;
};

const Page0 = lazy(() => import("@/pages/adjustment/page"));
const Page1 = lazy(() => import("@/pages/adjustment/[id]/edit/page"));
const Page2 = lazy(() => import("@/pages/adjustment/new/page"));
const Page3 = lazy(() => import("@/pages/ai/chat-logs/page"));
const Page4 = lazy(() => import("@/pages/ai/knowledge/page"));
const Page5 = lazy(() => import("@/pages/barcodes/page"));
const Page6 = lazy(() => import("@/pages/barcodes/[id]/edit/page"));
const Page7 = lazy(() => import("@/pages/barcodes/scan/page"));
const Page8 = lazy(() => import("@/pages/bonus/page"));
const Page9 = lazy(() => import("@/pages/bonus/[id]/edit/page"));
const Page10 = lazy(() => import("@/pages/bonus/accumulated/page"));
const Page11 = lazy(() => import("@/pages/bonus/adjustments/page"));
const Page12 = lazy(() => import("@/pages/bonus/adjustments/new/page"));
const Page13 = lazy(() => import("@/pages/bonus/points/page"));
const Page14 = lazy(() => import("@/pages/bonus/report/page"));
const Page14b = lazy(() => import("@/pages/bonus/income-tax/page"));
const Page15 = lazy(() => import("@/pages/branch/page"));
const Page16 = lazy(() => import("@/pages/branch/[id]/edit/page"));
const Page17 = lazy(() => import("@/pages/branch/new/page"));
const Page18 = lazy(() => import("@/pages/campaigns/birthday/page"));
const Page18b = lazy(() => import("@/pages/campaigns/special-addon/page"));
const Page18c = lazy(() => import("@/pages/campaigns/special-addon/new/page"));
const Page18d = lazy(() => import("@/pages/campaigns/special-addon/[id]/page"));
const Page19 = lazy(() => import("@/pages/campaigns/rising-star-leader-rewards/page"));
const Page20 = lazy(() => import("@/pages/campaigns/rising-star-leader-rewards/[id]/page"));
const Page21 = lazy(() => import("@/pages/campaigns/rising-star-leader-rewards/new/page"));
const Page22 = lazy(() => import("@/pages/change-password/page"));
const Page23 = lazy(() => import("@/pages/checkout-campaigns/page"));
const Page24 = lazy(() => import("@/pages/checkout-campaigns/[id]/page"));
const Page25 = lazy(() => import("@/pages/checkout-campaigns/new/page"));
const Page26 = lazy(() => import("@/pages/consignment/page"));
const Page27 = lazy(() => import("@/pages/credit-note/page"));
const Page28 = lazy(() => import("@/pages/credit-note/[id]/edit/page"));
const Page29 = lazy(() => import("@/pages/credit-note/new/page"));
const Page30 = lazy(() => import("@/pages/customer-voice/page"));
const Page31 = lazy(() => import("@/pages/customer-voice/[id]/page"));
const Page32 = lazy(() => import("@/pages/dashboard/page"));
const Page33 = lazy(() => import("@/pages/forbidden/page"));
const Page34 = lazy(() => import("@/pages/goods-return/page"));
const Page35 = lazy(() => import("@/pages/goods-return/[id]/edit/page"));
const Page36 = lazy(() => import("@/pages/goods-return/new/page"));
const Page37 = lazy(() => import("@/pages/invoices/page"));
const Page38 = lazy(() => import("@/pages/invoices-cancel/page"));
const Page39 = lazy(() => import("@/pages/invoices-einvoice/page"));
const Page40 = lazy(() => import("@/pages/invoices-einvoice/[invoiceId]/page"));
const Page41 = lazy(() => import("@/pages/invoices-pending/page"));
const Page42 = lazy(() => import("@/pages/invoices-pending/[id]/page"));
const Page43 = lazy(() => import("@/pages/invoices-reject/page"));
const Page44 = lazy(() => import("@/pages/invoices/[id]/edit/page"));
const Page45 = lazy(() => import("@/pages/invoices/new/page"));
const Page46 = lazy(() => import("@/pages/issue/page"));
const Page47 = lazy(() => import("@/pages/issue/[id]/edit/page"));
const Page48 = lazy(() => import("@/pages/issue/new/page"));
const Page49 = lazy(() => import("@/pages/loan-in/page"));
const Page50 = lazy(() => import("@/pages/loan-in/[id]/edit/page"));
const Page51 = lazy(() => import("@/pages/loan-in/new/page"));
const Page52 = lazy(() => import("@/pages/loan-out/page"));
const Page53 = lazy(() => import("@/pages/loan-out/[id]/edit/page"));
const Page54 = lazy(() => import("@/pages/loan-out/new/page"));
const Page55 = lazy(() => import("@/pages/login/page"));
const Page56 = lazy(() => import("@/pages/lucky-draw/page"));
const Page57 = lazy(() => import("@/pages/maintenance/page"));
const Page58 = lazy(() => import("@/pages/members/page"));
const Page59 = lazy(() => import("@/pages/members/[id]/page"));
const Page60 = lazy(() => import("@/pages/members/[id]/edit/page"));
const Page61 = lazy(() => import("@/pages/members/[id]/tree/page"));
const Page62 = lazy(() => import("@/pages/members/dashboard/page"));
const Page63 = lazy(() => import("@/pages/members/minds/page"));
const Page64 = lazy(() => import("@/pages/members/new/page"));
const Page65 = lazy(() => import("@/pages/members/xinmiao/page"));
const Page65b = lazy(() => import("@/pages/members/birthday-list/page"));
const Page66 = lazy(() => import("@/pages/products/page"));
const Page67 = lazy(() => import("@/pages/products/[id]/edit/page"));
const Page68 = lazy(() => import("@/pages/products/new/page"));
const Page69 = lazy(() => import("@/pages/reports/cp58/page"));
const Page69b = lazy(() => import("@/pages/reports/ajl/page"));
const Page70 = lazy(() => import("@/pages/reports/sales/page"));
const Page71 = lazy(() => import("@/pages/reports/sales-account/page"));
const Page72 = lazy(() => import("@/pages/roles/page"));
const Page73 = lazy(() => import("@/pages/roles/[id]/page"));
const Page74 = lazy(() => import("@/pages/self-pickup/page"));
const Page75 = lazy(() => import("@/pages/self-pickup/calendar/page"));
const Page76 = lazy(() => import("@/pages/settings/app-settings/page"));
const Page77 = lazy(() => import("@/pages/settings/banks/page"));
const Page78 = lazy(() => import("@/pages/settings/countries/page"));
const Page79 = lazy(() => import("@/pages/settings/delivery-charges/page"));
const Page80 = lazy(() => import("@/pages/settings/maintenance/page"));
const Page81 = lazy(() => import("@/pages/settings/notices/page"));
const Page82 = lazy(() => import("@/pages/settings/payment-modes/page"));
const Page83 = lazy(() => import("@/pages/settings/portal-tool-links/page"));
const Page84 = lazy(() => import("@/pages/settings/product-categories/page"));
const Page85 = lazy(() => import("@/pages/settings/product-categories/[id]/testimonials/page"));
const Page86 = lazy(() => import("@/pages/settings/push-notifications/page"));
const Page87 = lazy(() => import("@/pages/settings/states/page"));
const Page88 = lazy(() => import("@/pages/settings/suppliers/page"));
const Page89 = lazy(() => import("@/pages/settings/website-content/page"));
const Page90 = lazy(() => import("@/pages/stock-in/page"));
const Page91 = lazy(() => import("@/pages/stock-in/[id]/edit/page"));
const Page92 = lazy(() => import("@/pages/stock-in/new/page"));
const Page93 = lazy(() => import("@/pages/tickets/page"));
const Page94 = lazy(() => import("@/pages/tickets/[id]/page"));
const Page95 = lazy(() => import("@/pages/tickets/new/page"));
const Page96 = lazy(() => import("@/pages/tickets/solved/page"));
const Page97 = lazy(() => import("@/pages/training/programs/page"));
const Page98 = lazy(() => import("@/pages/training/programs/[id]/edit/page"));
const Page99 = lazy(() => import("@/pages/transfer/page"));
const Page100 = lazy(() => import("@/pages/transfer/[id]/edit/page"));
const Page101 = lazy(() => import("@/pages/transfer/new/page"));
const Page102 = lazy(() => import("@/pages/users/page"));
const Page103 = lazy(() => import("@/pages/users/[id]/page"));
const Page104 = lazy(() => import("@/pages/users/new/page"));
const Page105 = lazy(() => import("@/pages/vouchers/page"));
const Page105b = lazy(() => import("@/pages/vouchers/redeem-catalog/page"));
const Page105c = lazy(() => import("@/pages/vouchers/categories/page"));
const Page106 = lazy(() => import("@/pages/vouchers/[id]/page"));
const Page107 = lazy(() => import("@/pages/vouchers/new/page"));
const Page108 = lazy(() => import("@/pages/write-off/page"));
const Page109 = lazy(() => import("@/pages/write-off/[id]/edit/page"));
const Page110 = lazy(() => import("@/pages/write-off/new/page"));
const Page111 = lazy(() => import("@/pages/xmegami-picks/page"));
const Page112 = lazy(() => import("@/pages/training/events/page"));
const Page113 = lazy(() => import("@/pages/training/events/[id]/edit/page"));
const Page114 = lazy(() => import("@/pages/products/dashboard/page"));
const Page115 = lazy(() => import("@/pages/roadmap-2027/page"));
const Page116 = lazy(() => import("@/pages/roadmap-2027/redemptions/page"));
const Page117 = lazy(() => import("@/pages/roadmap-2027/settings/page"));
const Page118 = lazy(() => import("@/pages/roadmap-2027/jump-start/page"));
const Page119 = lazy(() => import("@/pages/roadmap-2027/quarters/page"));
const Page120 = lazy(() => import("@/pages/roadmap-2027/credits/page"));

export const adminPageRoutes: AdminRoute[] = [
  { path: "/adjustment", Component: Page0 },
  { path: "/adjustment/:id/edit", Component: Page1 },
  { path: "/adjustment/new", Component: Page2 },
  { path: "/ai/chat-logs", Component: Page3 },
  { path: "/ai/knowledge", Component: Page4 },
  { path: "/barcodes", Component: Page5 },
  { path: "/barcodes/:id/edit", Component: Page6 },
  { path: "/barcodes/scan", Component: Page7 },
  { path: "/bonus", Component: Page8 },
  { path: "/bonus/:id/edit", Component: Page9 },
  { path: "/bonus/accumulated", Component: Page10 },
  { path: "/bonus/adjustments", Component: Page11 },
  { path: "/bonus/adjustments/new", Component: Page12 },
  { path: "/bonus/points", Component: Page13 },
  { path: "/bonus/report", Component: Page14 },
  { path: "/bonus/income-tax", Component: Page14b },
  { path: "/branch", Component: Page15 },
  { path: "/branch/:id/edit", Component: Page16 },
  { path: "/branch/new", Component: Page17 },
  { path: "/campaigns/birthday", Component: Page18 },
  { path: "/campaigns/special-addon", Component: Page18b },
  { path: "/campaigns/special-addon/new", Component: Page18c },
  { path: "/campaigns/special-addon/:id", Component: Page18d },
  { path: "/campaigns/rising-star-leader-rewards", Component: Page19 },
  { path: "/campaigns/rising-star-leader-rewards/:id", Component: Page20 },
  { path: "/campaigns/rising-star-leader-rewards/new", Component: Page21 },
  { path: "/change-password", Component: Page22 },
  { path: "/checkout-campaigns", Component: Page23 },
  { path: "/checkout-campaigns/:id", Component: Page24 },
  { path: "/checkout-campaigns/new", Component: Page25 },
  { path: "/consignment", Component: Page26 },
  { path: "/credit-note", Component: Page27 },
  { path: "/credit-note/:id/edit", Component: Page28 },
  { path: "/credit-note/new", Component: Page29 },
  { path: "/customer-voice", Component: Page30 },
  { path: "/customer-voice/:id", Component: Page31 },
  { path: "/dashboard", Component: Page32 },
  { path: "/forbidden", Component: Page33 },
  { path: "/goods-return", Component: Page34 },
  { path: "/goods-return/:id/edit", Component: Page35 },
  { path: "/goods-return/new", Component: Page36 },
  { path: "/invoices", Component: Page37 },
  { path: "/invoices-cancel", Component: Page38 },
  { path: "/invoices-einvoice", Component: Page39 },
  { path: "/invoices-einvoice/:invoiceId", Component: Page40 },
  { path: "/invoices-pending", Component: Page41 },
  { path: "/invoices-pending/:id", Component: Page42 },
  { path: "/invoices-reject", Component: Page43 },
  { path: "/invoices/:id/edit", Component: Page44 },
  { path: "/invoices/new", Component: Page45 },
  { path: "/issue", Component: Page46 },
  { path: "/issue/:id/edit", Component: Page47 },
  { path: "/issue/new", Component: Page48 },
  { path: "/loan-in", Component: Page49 },
  { path: "/loan-in/:id/edit", Component: Page50 },
  { path: "/loan-in/new", Component: Page51 },
  { path: "/loan-out", Component: Page52 },
  { path: "/loan-out/:id/edit", Component: Page53 },
  { path: "/loan-out/new", Component: Page54 },
  { path: "/login", Component: Page55 },
  { path: "/lucky-draw", Component: Page56 },
  { path: "/maintenance", Component: Page57 },
  { path: "/members", Component: Page58 },
  { path: "/members/birthday-list", Component: Page65b },
  { path: "/members/:id", Component: Page59 },
  { path: "/members/:id/edit", Component: Page60 },
  { path: "/members/:id/tree", Component: Page61 },
  { path: "/members/dashboard", Component: Page62 },
  { path: "/members/minds", Component: Page63 },
  { path: "/members/new", Component: Page64 },
  { path: "/members/xinmiao", Component: Page65 },
  { path: "/products", Component: Page66 },
  { path: "/products/:id/edit", Component: Page67 },
  { path: "/products/dashboard", Component: Page114 },
  { path: "/products/new", Component: Page68 },
  { path: "/reports/ajl", Component: Page69b },
  { path: "/reports/cp58", Component: Page69 },
  { path: "/reports/sales", Component: Page70 },
  { path: "/reports/sales-account", Component: Page71 },
  { path: "/roles", Component: Page72 },
  { path: "/roadmap-2027", Component: Page115 },
  { path: "/roadmap-2027/credits", Component: Page120 },
  { path: "/roadmap-2027/jump-start", Component: Page118 },
  { path: "/roadmap-2027/quarters", Component: Page119 },
  { path: "/roadmap-2027/redemptions", Component: Page116 },
  { path: "/roadmap-2027/settings", Component: Page117 },
  { path: "/roles/:id", Component: Page73 },
  { path: "/self-pickup", Component: Page74 },
  { path: "/self-pickup/calendar", Component: Page75 },
  { path: "/settings/app-settings", Component: Page76 },
  { path: "/settings/banks", Component: Page77 },
  { path: "/settings/countries", Component: Page78 },
  { path: "/settings/delivery-charges", Component: Page79 },
  { path: "/settings/maintenance", Component: Page80 },
  { path: "/settings/notices", Component: Page81 },
  { path: "/settings/payment-modes", Component: Page82 },
  { path: "/settings/portal-tool-links", Component: Page83 },
  { path: "/settings/product-categories", Component: Page84 },
  { path: "/settings/product-categories/:id/testimonials", Component: Page85 },
  { path: "/settings/push-notifications", Component: Page86 },
  { path: "/settings/states", Component: Page87 },
  { path: "/settings/suppliers", Component: Page88 },
  { path: "/settings/website-content", Component: Page89 },
  { path: "/stock-in", Component: Page90 },
  { path: "/stock-in/:id/edit", Component: Page91 },
  { path: "/stock-in/new", Component: Page92 },
  { path: "/tickets", Component: Page93 },
  { path: "/tickets/:id", Component: Page94 },
  { path: "/tickets/new", Component: Page95 },
  { path: "/tickets/solved", Component: Page96 },
  { path: "/training/events", Component: Page112 },
  { path: "/training/events/:id/edit", Component: Page113 },
  { path: "/training/programs", Component: Page97 },
  { path: "/training/programs/:id/edit", Component: Page98 },
  { path: "/transfer", Component: Page99 },
  { path: "/transfer/:id/edit", Component: Page100 },
  { path: "/transfer/new", Component: Page101 },
  { path: "/users", Component: Page102 },
  { path: "/users/:id", Component: Page103 },
  { path: "/users/new", Component: Page104 },
  { path: "/vouchers", Component: Page105 },
  { path: "/vouchers/redeem-catalog", Component: Page105b },
  { path: "/vouchers/categories", Component: Page105c },
  { path: "/vouchers/new", Component: Page107 },
  { path: "/vouchers/:id", Component: Page106 },
  { path: "/write-off", Component: Page108 },
  { path: "/write-off/:id/edit", Component: Page109 },
  { path: "/write-off/new", Component: Page110 },
  { path: "/xmegami-picks", Component: Page111 },
];
